import { publishableInstagramPostTypeSchema } from "@runcheetah/shared";

import { isInstagramPublicationPending } from "@/lib/instagram-publication";

export const canPublishPostNow = (input: {
  postStatus: string;
  approvalStatus: string;
  postType: string;
  instagramConnected: boolean;
  publication?: {
    status?: string | null;
    publishNowRequestedAt?: string | null;
  } | null;
  isPublishing: boolean;
}): boolean =>
  input.postStatus === "generated" &&
  input.approvalStatus === "approved" &&
  publishableInstagramPostTypeSchema.safeParse(input.postType).success &&
  input.instagramConnected &&
  !input.isPublishing &&
  !isInstagramPublicationPending(input.publication) &&
  input.publication?.status !== "published";
